import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef, useRef, useCallback } from 'react';
import { Transition } from 'react-transition-group';
import { O as Overlay } from './Overlay-CmPZ6zSu.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { P as Portal } from '../Portal/Portal-CfuGnhf3.js';

/**
 * Expose all the ContextualDrawer Props and the passthrough props of the `<div>` element
 */

/*
 * ContextualDrawerComponent is a workaround for the types generated by forwardRef() when wrapping a type
 * created by MergeStyledComponentElementProps. By default, the type generated will have all the known
 * attributes of the HTML listed out. This creates a problem for older version of the lib.dom.d.ts that
 * ships with typescript because it will be missing any new attributes. e.g. the `nonce` attribute
 * was added TS 3.2.0, so earlier versions of TS do not recognize it as optional.
 */

const ContextualDrawer = /*#__PURE__*/forwardRef(({
  children,
  closeButtonLabel = '',
  closeButtonProps,
  isOpen = false,
  onClose = noop,
  withCloseButton = true,
  taktId,
  taktValue,
  ...rest
}, ref) => {
  const drawerContainerRef = useRef(null);
  const handleCloseButtonClicked = useCallback(event => {
    if (onClose) {
      onClose(event);
    }
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('contextual-drawer')
  }, /*#__PURE__*/React__default.createElement(Transition, {
    timeout: 150,
    appear: true,
    in: isOpen,
    nodeRef: drawerContainerRef
  }, slideState => {
    if (slideState === 'exited') return null;
    return /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement(Overlay, _extends({}, rest, {
      ref: ref,
      drawerContainerRef: drawerContainerRef,
      slideState: slideState,
      withCloseButton: withCloseButton,
      closeButtonLabel: closeButtonLabel,
      handleCloseButtonClicked: handleCloseButtonClicked,
      closeButtonProps: closeButtonProps
    }), children));
  }));
});
ContextualDrawer.displayName = 'ContextualDrawer';

export { ContextualDrawer as C };
//# sourceMappingURL=ContextualDrawer-CVnnaPrq.js.map
